import PropTypes from 'prop-types';
import React from 'react';

import appleIcon from '../assets/auth/apple.svg';
import facebookIcon from '../assets/auth/facebook.svg';
import googleIcon from '../assets/auth/google.svg';

const icons = {
  google: googleIcon,
  apple: appleIcon,
  facebook: facebookIcon,
};

const providerLabels = {
  google: 'Google',
  apple: 'Apple',
  facebook: 'Facebook',
};

export default function AuthSocialButtons({
  providers,
  onProviderClick,
  disabled,
  highlightedProvider,
}) {
  return (
    <div className='auth-social-buttons'>
      {providers.map((provider) => {
        const icon = icons[provider];
        return (
          <button
            key={provider}
            type='button'
            className={`auth-social-button${
              highlightedProvider === provider ? ' is-highlighted' : ''
            }`}
            onClick={() => onProviderClick(provider)}
            disabled={disabled}
            aria-label={providerLabels[provider] || provider}>
            {icon ? (
              <img src={icon} alt='' aria-hidden='true' />
            ) : (
              <span className='auth-social-button__label'>
                {providerLabels[provider] || provider}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

AuthSocialButtons.defaultProps = {
  // Prefer passing providers from Auth.jsx (AUTH_OAUTH_PROVIDERS). Google OAuth disabled for this release.
  providers: [],
  disabled: false,
  highlightedProvider: null,
};

AuthSocialButtons.propTypes = {
  providers: PropTypes.arrayOf(PropTypes.string),
  onProviderClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  highlightedProvider: PropTypes.string,
};
